<template>
  <div>
    <search-bar :items="[
      { key: 'create_time', label: 'Date', type: 'daterange', placeholder: 'Date', times: dates, defaultValue: defaultDateRange },
      { key: 'sales_id', label: 'Sales', type: 'select', state: 'sales', option_value: 'id', option_label: 'realname', defaultValue: user.id },
      { key: 'type_1', label: 'Trade/Factory', type: 'select', state: 'trade_or_factory' }
    ]" @search="search"/>
    
    <div class="card">
      <el-pagination @size-change="pageSizeChange" @current-change="pageChange" :current-page="currentPage" :page-sizes="[20, 50, 100, 500]" :page-size="pageSize" layout="total, sizes, pager" :total="total" style="text-align:right;"></el-pagination>
      <table class="normal-table">
        <tr>
          <th>#</th>
          <th style="width:340px;">Company Name</th>
          <th>Company ID</th>
          <th>Country</th>
          <th>Trade/Factory</th>
          <th>Create Date</th>
          <th>Create By</th>
          <th>Sales 1</th>
          <th>Veritied by</th>
        </tr>
        <tr v-for="(item, index) in list" :key="item.id">
          <td>{{ index + 1 }}</td>
          <td><a :href="'/customer/company/' + item.id" target="_blank">{{ item.name }}</a></td>
          <td>{{ item.id }}</td>
          <td>{{ item.country }}</td>
          <td>{{ item.type_1 }}</td>
          <td>{{ item.create_time.substr(0, 10) }}</td>
          <td>{{ item.create_oper_name }}</td>
          <td>{{ item.sales_name }}</td>
          <td v-if="!item.veritied_oper_name"><el-button type="text" @click="openDialog(item)">verify</el-button></td>
          <td v-else>{{ item.veritied_oper_name }}</td>
        </tr>
      </table>
      <no-data :loading="loading" :list="list"></no-data>
    </div>
    <el-dialog :title="formTitle" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <div>
        Director Remark:<br/>
        <el-input type="textarea" class="hide-input" v-model="form.director_remark"></el-input>
      </div>
      <div style="text-align:center;margin-top:20px;">
        <el-button type="primary" @click="verify">Save</el-button>
        <el-button @click="dialogVisible = false">Cancel</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import ListFunc from '@/mixins/ListFunc'
import NoData from '@/components/NoData'
export default {
  mixins: [ListFunc],
  components: {
    NoData
  },
  data () {
    return {
      sqlcode: 'company_list',
      pageSize: 100,
      defaultDateRange: [moment().subtract(7, 'days'), moment().endOf('day')],
      dates: [
        { text: 'All', value: [] },
        { text: '1 week', value: [moment().subtract(7, 'days'), moment().endOf('day')] },
        { text: '1 month', value: [moment().subtract(1, 'months'), moment().endOf('day')] },
        { text: '3 month', value: [moment().subtract(3, 'months'), moment().endOf('day')] },
        { text: '6 month', value: [moment().subtract(6, 'months'), moment().endOf('day')] },
        { text: 'This Month', value: [moment().startOf('month'), moment().endOf('day')] },
        { text: 'Last Month', value: [moment().subtract(1, 'months').startOf('month'), moment().subtract(1, 'months').endOf('month')] },
        { text: 'This Year', value: [moment().startOf('year'), moment().endOf('day')] },
        { text: 'Last Year', value: [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')] }
      ],
      dialogVisible: false,
      formTitle: '',
      form: {
        id: 0,
        director_remark: ''
      }
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    openDialog (item) {
      this.formTitle = item.name
      this.form.id = item.id
      this.form.director_remark = item.director_remark
      this.dialogVisible = true
    },
    verify () {
      this.$http.post('/dbapi/company_verify', this.form).then(data => {
        this.$message({
          type: 'success',
          message: '保存成功'
        })
        this.dialogVisible = false
        this.refresh()
      })
    }
  }
}
</script>

<style>
.hide-input .el-textarea__inner {
  background-color: yellow;
}
</style>